const constants = {
  devEnv: {
    storeSubdomain: "nonchalant",
  },
  fontFamily: {
    defaultFont: "Montserrat",
  },
};

export default constants;
